import type { DeviceStatusSubscriptionAPI } from './Definitions';

import type { DeviceStatusSubscription } from '@cobliteam/common-types';

export const toDeviceStatusSubscription = (
  deviceStatusSubscriptionAPI: DeviceStatusSubscriptionAPI
): DeviceStatusSubscription => ({
  id: deviceStatusSubscriptionAPI.id,
  active: deviceStatusSubscriptionAPI.active,
  vehicleIds: deviceStatusSubscriptionAPI.vehicle_ids,
  vehicleGroupIds: deviceStatusSubscriptionAPI.vehicle_group_ids,
});

export const toDeviceStatusSubscriptionAPI = (
  subscription: DeviceStatusSubscription
): DeviceStatusSubscriptionAPI => ({
  id: subscription.id,
  active: subscription.active,
  vehicle_ids: subscription.vehicleIds,
  vehicle_group_ids: subscription.vehicleGroupIds,
});
